/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shop_Toggle_Miniapp_AriaInputs */

const vi_shop_toggle_miniapp_aria = /** @type {(inputs: Shop_Toggle_Miniapp_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hiện ${i?.name} trên Zalo Mini App`)
};

/**

* @param {Shop_Toggle_Miniapp_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_toggle_miniapp_aria = /** @type {((inputs: Shop_Toggle_Miniapp_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Toggle_Miniapp_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_toggle_miniapp_aria(inputs)
});